import React, { useState, useEffect, useRef, useContext } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
// import { Row, Col } from "react-bootstrap";
import "../Assests/Scss/ReportCard.scss";
import { AssessmentName } from "../Reusablecomponents/RegularFunctions";
import ReuseTable from "../../ReusableComponents/Table";
import InternetChecking from "../Reusablecomponents/Network";
import NSFLOgo from "../Assests/Images/NSFLOgo.jpg";
import { FaLightbulb } from "react-icons/fa";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import { FaGraduationCap } from "react-icons/fa";
import { FaSchool } from "react-icons/fa";
import { HiMiniIdentification } from "react-icons/hi2";
import { FaPenToSquare } from "react-icons/fa6";
import { renderToString } from "react-dom/server";
import { SiLevelsdotfyi } from "react-icons/si";
const ReportCard = () => {
  const location = useLocation();
  const { SetLoad } = useContext(LoadContext);
  const ReportsRef = useRef();
  const [SWPercentage, SetSWPercentage] = useState();
  const [DLWTable, SetDLWTable] = useState();
  const [Foucs, SetFocus] = useState();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const FetchallAPIs = async () => {
    SetLoad(true);
    try {
      const [SUbjectWisePercentage, DL, FocusArea] = await Promise.all([
        axiosInstance.get(
          `/StudentResults/GetStudentSubjectwisePerformance?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}&AssessmentType=${location.state.AType}`,
        ),
        axiosInstance.get(
          `/StudentResults/StudentReportDifficultyLevelByAssessment?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}&AssessmentType=${location?.state?.AType}&Grade=${items?.grade}&Set=1`,
        ),
        axiosInstance.get(
          `/StudentResults/GetStudentFocusonLODetails?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}&AssessmentType=${location.state.AType}`,
        ),
      ]);
      const SWPTotal = {
        subjectName: "Total",
        percentage: SUbjectWisePercentage.data?.[0]?.overallPercentage,
        obtainedCredits: SUbjectWisePercentage.data?.reduce(
          (sum, item) => sum + item.obtainedCredits,
          0,
        ),
        totalCredits: SUbjectWisePercentage.data?.reduce(
          (sum, item) => sum + item.totalCredits,
          0,
        ),
      };
      SetSWPercentage([...SUbjectWisePercentage.data, SWPTotal]);

      const FormatDL = DL.data.reduce((acc, item) => {
        const Sub = item.subjectName;
        if (!acc[Sub]) {
          acc[Sub] = { subjectName: Sub, low: 0, medium: 0, high: 0 };
        }
        if (item.difficultyLevel.includes("Low"))
          acc[Sub].low = item.percentage;
        if (item.difficultyLevel.includes("Medium"))
          acc[Sub].medium = item.percentage;
        if (item.difficultyLevel.includes("High"))
          acc[Sub].high = item.percentage;
        return acc;
      }, {});
      SetDLWTable(Object.values(FormatDL));

      const Subjects = FocusArea.data.reduce((acc, item) => {
        if (!acc[item.subjectName]) {
          acc[item.subjectName] = [];
        }
        acc[item.subjectName].push(item);
        return acc;
      }, {});
      SetFocus(Subjects);
    } catch (err) {
      console.log(err);
    } finally {
      SetLoad(false);
    }
  };
  useEffect(() => {
    FetchallAPIs();
  }, []);

  const replaceCanvasWithImages = () => {
    const canvases = document.querySelectorAll("canvas");
    canvases.forEach((canvas) => {
      const img = document.createElement("img");
      img.src = canvas.toDataURL("image/png");
      img.style.width = canvas.style.width;
      img.style.height = canvas.style.height;
      img.className = "chart-image";
      canvas.replaceWith(img);
    });
  };

  const copyAllStyles = () => {
    let styles = "";
    for (let sheet of document.styleSheets) {
      try {
        if (sheet.href) {
          styles += `<link rel="stylesheet" href="${sheet.href}" />`;
        } else if (sheet.cssRules) {
          // inline style blocks (used by SCSS injected styles)
          let rules = "";
          for (let rule of sheet.cssRules) {
            rules += rule.cssText;
          }
          styles += `<style>${rules}</style>`;
        }
      } catch (err) {
        console.log("Skipping stylesheet", err);
      }
    }
    return styles;
  };

  const DownloadPDF = async () => {
    try {
      const payload = {
        userTypeId: items?.userTypeId || 0,
        userId: items?.userId || 0,
        reportType: "Student Report Card",
        contestCreationId: location.state?.CCID || 0,
        assessmentTypeId: location?.state?.AType || 0
      };
      await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);

    } catch (error) {
      console.error("Error logging report download:", error);
    }
    const stylesheets = copyAllStyles();
    replaceCanvasWithImages();
    const printContents = ReportsRef.current.innerHTML;
    const printWindow = window.open("", "", "height=800,width=600");
    const filename = `NCP_ReportCard_${items?.fullName}_${AssessmentName(
      location?.state?.AType,
    )}_${location?.state?.Date}`;
    printWindow.document.write(`
    <html>
      <head>
      ${stylesheets}
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 12px;
              position: relative;
               -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
            }
           
 
  .print-only {
    display: block !important;
  }
    
    table th {
     font-size: 12px;
  background-color: #025f9e !important; 
  color: #f6fffe !important;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
  table tbody td,.ft-18 {
  font-size: 12px !important;
}
            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
}

.Icons-Div div {
  flex: 1;
  text-align: center;
}
  .RC_Details,.RC_Details div div{
  gap:5px !important;}
   .RC_Details div div div{
   padding: 5px!important;}
.Icons-Div img {
              width: 20%;
              // height: 60px;
            }
             
                   .EndReport{
                  margin-top: 15px;
              }
                   .SubHeading,.MainHeading{
 font-weight:700 !important;
 font-size: 14px;}

      
            /* Ensure watermark appears on every page */
            @page {
              size: A4;
              margin: 7mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="p-3 m-2" style="border: 2px solid #1e40ae; border-radius: 20px;">
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
       <div class="MainHeading">STUDENT REPORT CARD</div>
       <div></div>
      </div>
<hr/>
<div class="Icons-Div">
<div class="MainHeading">${AssessmentName(location?.state?.AType)} conducted on ${location?.state?.Date} </div>
  </div>

        <div class="dflex JSBetween gap-3 ">
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1">${renderToString(<FaPenToSquare />)}STUDENT NAME</b> ${items?.fullName} </div>
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1"> ${renderToString(<FaGraduationCap />)}GRADE / SECTION</b> Grade ${items?.grade} - Section ${items.section} </div>
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1">${renderToString(<HiMiniIdentification />)}STUDENT ID</b> ${items?.studentId} </div>
            <div class="dflex flexd-column alignitems" style="text-wrap-mode: wrap;"><b class="dflex gap-1">${renderToString(<FaSchool />)}SCHOOL</b> ${items?.schoolName} </div>
          </div>
          </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div class="Icons-Div"> <div>**  End of the Report  **</div></div>
      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
              }, 400);
              }
              <\/script>
              </body>
              </html>
              `);
    printWindow.document.close();
  };
  const FocusColumns = [
    {
      name: "Subject",
      selector: "subjectName",
      cell: (row) => (
        <div
          className="w-50"
          style={{
            backgroundColor: SubColors(row.subjectName)?.[1],
            display: "inline-block",
          }}
        >
          {row.subjectName}
        </div>
      ),
    },
    {
      name: "Low Level",
      selector: "low",
      cell: (row) => (
        <div
          className="w-25 "
          style={{
            backgroundColor: Percentagecolor(row.low),
            display: "inline-block",
          }}
        >
          {row.low}%
        </div>
      ),
    },
    {
      name: "Medium Level",
      selector: "medium",
      cell: (row) => (
        <div
          className="w-25"
          style={{
            backgroundColor: Percentagecolor(row.medium),
            display: "inline-block",
          }}
        >
          {row.medium}%
        </div>
      ),
    },
    {
      name: "High Level",
      selector: "high",
      cell: (row) => (
        <div
          className="w-25"
          style={{
            backgroundColor: Percentagecolor(row.high),
            display: "inline-block",
          }}
        >
          {row.high}%
        </div>
      ),
    },
  ];
  const Percentagecolor = (e) => {
    switch (true) {
      case e <= 50:
        return "#fba5a5";
      case e > 50 && e <= 74:
        return "#fbb872";
      case e > 74:
        return "#86efab";
    }
  };

  const SubColors = (Sub) => {
    switch (Sub) {
      case "English":
        return ["#1ca078", "#9fdecb"];
      case "Mathematics":
        return ["#3653b7", "#9db2fa"];
      case "Science":
        return ["#ec6722", "#ffc7aa"];
      case "Physics and Chemistry":
        return ["#875998", "#dcaded"];
      case "Biology":
        return ["#7d859e", "#e7e7e7"];
      case "Total":
        return ["#bb5f5f", "#fbc3c3"];
      case "BioTechnology":
        return ["#bb995f", "#d8bc8d"];
      case "Hindi":
        return ["#f96393","#f9a0bc"]; 
      case "Telugu":
        return ["#AD46FF","#d6a2ff"];
      default:
        return ["#5657d4", "#92b5ff"];
    }
  };
  return (
    <>
      <div className="Instructions-pages PMain-Div">
        <InternetChecking />
        <div
          className="p-3 mb-3"
          style={{ border: "2px solid #1e40ae", borderRadius: "20px" }}
        >
          <div className="dflex JSBetween alignitems">
            <div></div>
            <div className="dflex JCCenter flexd-column gap-2 alignitems">
              <div className="MainHeading mt-2" style={{ color: "blue" }}>
                {" "}
                Student Report Card{" "}
              </div>
              <div className="SubHeading">
                {" "}
                {AssessmentName(location?.state?.AType)} conducted on{" "}
                {location?.state?.Date}{" "}
              </div>
            </div>
            <button className="Buttons p-2" onClick={() => DownloadPDF()}>
              {" "}
              Download Report{" "}
            </button>
          </div>
          <hr />
          <div className="dflex JSBetween ">
            <div className="dflex flexd-column alignitems">
              <b>
                <FaPenToSquare /> STUDENT NAME
              </b>{" "}
              {items?.fullName}{" "}
            </div>
            <div className="dflex flexd-column alignitems">
              <b>
                <FaGraduationCap /> GRADE / SECTION
              </b>{" "}
              Grade {items?.grade} - Section {items.section}{" "}
            </div>
            <div className="dflex flexd-column alignitems">
              <b>
                <HiMiniIdentification /> STUDENT ID
              </b>{" "}
              {items?.studentId}{" "}
            </div>
            <div className="dflex flexd-column alignitems">
              <b>
                <FaSchool /> SCHOOL
              </b>{" "}
              {items?.schoolName}{" "}
            </div>
          </div>
        </div>
        <div ref={ReportsRef}>
          <div className="dflex gap-3 RC_Details">
            {SWPercentage?.map((SDetails) => (
              <div
                className="Card  w-100 "
                style={{
                  color: "black",
                  textAlign: "center",
                  backgroundColor: SubColors(SDetails.subjectName)?.[0],
                }}
              >
                <p style={{ color: "white", fontFamily: "inherit" }}>{SDetails.subjectName}</p>
                <div className="dflex gap-3 mt-2">
                  <div
                    className="Card w-100 flexd-column dflex"
                    style={{
                      backgroundColor: SubColors(SDetails.subjectName)?.[1],
                    }}
                  >
                    Marks
                    <b >
                      {/* {" "}className="ft-18" */}
                      {SDetails.obtainedCredits}/{SDetails.totalCredits}
                    </b>
                  </div>
                  <div
                    className="Card w-100 flexd-column dflex"
                    style={{
                      backgroundColor: SubColors(SDetails.subjectName)?.[1],
                    }}
                  >
                    {" "}
                    Percentage
                    <b className="ft-18"> {SDetails.percentage}%</b>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="SubHeading mt-3"><SiLevelsdotfyi /> Difficulty Level–wise Performance Analysis</div>

          <ReuseTable
            className="STudenTable ReportCardTable Card mt-1"
            data={DLWTable}
            columns={FocusColumns}
          />
          <div className="SubHeading mt-3"><FaLightbulb />Learning Outcomes to focus</div>

          <div className="gap-3 dflex mb-2">
            {Foucs &&
              Object.entries(Foucs)?.map(([Subject, Los]) => (
                <>
                  <div
                    className="Card TDFArea mt-2 w-100"
                    style={{
                      backgroundColor: SubColors(Subject)?.[0],
                      color: "white",
                      WebkitPrintColorAdjust: "exact",
                      printColorAdjust: "exact",
                    }}
                  >
                    <div>{Subject}</div>
                    <hr className="m-2" />
                    <ul>
                      {Los?.map((LO) => (
                        <li>
                          {LO?.lo}
                          {/* {LO?.lo && `${LO?.lo} - `}{" "}
                          {LO?.subjectAveragePercentage}% */}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ))}
          </div>
        </div>
        <CopyRight />
      </div>
    </>
  );
};
export default ReportCard;
